import {app} from '../../app';
import {SharedQuestionService} from "../../services/SharedQuestionService";
import {ISessionService} from "../../services/SessionService";
import {UniqueIdService} from "../../services/UniqueIdService";
import {RadioGridSharedQuestion} from "../../sharedQuestions/RadioGridSharedQuestion";

export class RadioQuestionComponent {

    protected uniqueIdService:UniqueIdService;
    protected sharedQuestionService:SharedQuestionService;
    protected sessionService:ISessionService;

    sharedQuestion:RadioGridSharedQuestion;

    question:IQuestion;
    nextQuestionCallback;
    value:string[] = [];

    choices:string[] = [];
    rows:string[] = [];
    style = 'default';

    ids = {};

    static $inject = ['UniqueIdService', 'SharedQuestionService', 'SessionService'];

    constructor(UniqueIdService:UniqueIdService, sharedQuestionService:SharedQuestionService, sessionService:ISessionService) {
        this.uniqueIdService = UniqueIdService;
        this.sharedQuestionService = sharedQuestionService;
        this.sessionService = sessionService;
    }

    public $onInit = () => {
        this.sharedQuestion = new RadioGridSharedQuestion();

        this.setup();
    };

    setup() {
        this.sharedQuestion.question = this.question;

        this.sharedQuestionService.questions.push(this.sharedQuestion);
        this.sharedQuestion.questionDisplayed();

        let style = this.question.meta.style;
        if (style) {
            this.style = style;
        }

        this.choices = this.question.meta.choices;
        this.rows = this.question.meta.rows;
        for (let row of this.rows) {
            this.value.push("");
        }

        for (let row = 0; row < this.rows.length; row++) {
            for (let choice = 0; choice < this.choices.length; choice++) {
                const id = row + '-' + choice;
                this.ids[id] = this.uniqueIdService.getUniqueId('radio-grid-' + id);
            }
        }

        let defaultValues = this.question.meta.default;
        if (defaultValues && angular.isArray(defaultValues)) {
            for (let defaultValue of defaultValues) {
                if (defaultValue['choice'] && defaultValue['row']) {
                    let row = defaultValue['row'];
                    this.value[row] = defaultValue['choice'];
                    this.update(row);
                }
            }
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            for (let value of answer.values) {
                let row = value.row;
                this.value[row] = this.choices[value.choice];
                this.update(row);
            }
        }
    }

    public update(row:number) {
        if (!this.value[row]) {
            return;
        }

        let newValue:IValue = {
            choice: this.choices.indexOf(this.value[row]),
            row: row,
            value: true
        };
        this.sharedQuestion.setValue(newValue);
    }

}

app.component('radioGridQuestion', {
    templateUrl: 'templates/components/questionTypes/radioGridQuestion.html',
    controller: RadioQuestionComponent,
    controllerAs: 'radioGridQuestion',
    bindings: {
        question: '<',
        nextQuestionCallback: '&'
    }
});